export const environment = {
  production: true,
  sentry_env: 'dev',
  env: 'dev',
  version: '5.0.2',
  logging: 'info', // debug, info, warn, error
  UPLOAD_API_KEY: 'eeqaluq2OuaXqdxrxRqjC3tbRQEwsNHH6l1iUR04',
  API_URL: 'https://dev.fdm.api.treesoflives.com',
  APP_URL: 'https://dev.fdm.treesoflives.com',
  RESTRICTED_BUCKET: 'treesoflives-field-data-infra-dev-restricted-docs',
  AWS_REGION: 'us-east-1',
  API_SERVICE: 'execute-api',
  IDENTITY_POOL_ID: 'us-east-1:d56218b1-d97f-45e3-ba2b-0eb3c8dfb454',
  USER_POOL_ID: 'us-east-1_osDGxfVQ4',
  USER_POOL_WEB_CLIENT_ID: '6a33sdadr1f0cf9nei9us1gdpb',
  API_NAME: 'fdm-api',
  SENTRY_DSN: 'https://6038cbf0eb2349ea96f086fc05853508@o490175.ingest.sentry.io/5735270',
  BUCKET_AVATARS: 'treesoflives-field-data-infra-dev-uploads-public',
  BUCKET_MEDIABUNDLES: 'treesoflives-field-data-infra-dev-uploads',
  BUCKET_MEDIABUNDLES_THUMBNAILS: 'treesoflives-field-data-infra-dev-uploads-public',
  BUCKET_DYNAMICFORM_THUMBNAILS: 'treesoflives-field-data-infra-dev-uploads-public',
  GOOGLE_API_KEY: 'AIzaSyB0yVfcIffKZ1zIOzJ0zRcyJC2F4c0VdSM',
  origin: 'https://dev.fdm.treesoflives.com',
  SENTRY_AUTH_TOKEN: 'e5b2ec73af4d499b96ef729eae435d7c2ab87878c1c14c6db271ce156c64f8e1',
  DOWNLINK_TRESHOLD: '0.2',
  HERE_API_KEY: '9x2CSrINfWbkkUmsALQbXFguPfVP4q6UPnn6DoqRko0',
  MAP_TILER_API_KEY: 'cvwn3Ud6pu4w6T357xFi',
  BING_API_KEY: 'AuUIY0hLOeAsnUUVA5RmwjaYWEKNIejk2lx6GyBRITYiQShyMgDHcRqk7CcV1iZw',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';
